import { Package, AlertTriangle, TrendingDown, Clock } from "lucide-react";

const StatsCards = ({ stats, user, pendingPOsCount }) => {
  const statCards = [
    { title: "Total Items", value: stats?.total_items || 0, icon: Package, color: "text-slate-900" },
    { title: "Low Stock Alerts", value: stats?.low_stock_items || 0, icon: AlertTriangle, color: "text-orange-500" },
    { title: "Out of Stock", value: stats?.out_of_stock || 0, icon: TrendingDown, color: "text-red-600" },
  ];

  if (user?.role === 'admin') {
    statCards.push({
      title: "Pending POs",
      value: pendingPOsCount,
      icon: Clock,
      color: "text-blue-600"
    });
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${user?.role === 'admin' ? '4' : '3'} gap-6 mb-8`}>
      {statCards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div
            key={index}
            data-testid={`stat-card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
            className="bg-white border border-slate-200 rounded-sm p-6"
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs text-slate-600 font-bold uppercase tracking-wider" style={{ fontFamily: 'Chivo, sans-serif' }}>
                  {card.title}
                </p>
                <p className="text-3xl font-bold text-slate-900 mt-2" style={{ fontFamily: 'IBM Plex Sans, monospace' }}>
                  {card.value}
                </p>
              </div>
              <Icon className={`${card.color}`} size={24} strokeWidth={2} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { StatsCards };
